import {Component, OnInit, ViewChild, Input, Output, EventEmitter, NgZone} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../services';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit {

  @Input() edit: boolean;
  @Input() linkFile;
  @Output() changeFile = new EventEmitter();
  @ViewChild('fileInput') fileInput;
  public file;
  public url;

  constructor(
    private translate: TranslateService,
    private modalService: ModalService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.url = environment.avatar_url;
  }

  onFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];

      if (!file.type.includes('audio')) {
        this.modalService.open(this.translate.instant('DOCUMENTS.FILE_MUST_BE_AUDIO'));
        this.file = null;
        this.linkFile = null;
        this.fileInput.nativeElement.value = null;
        this.changeFile.emit(null);
        return false;
      }

      if (Math.round(file.size / 1000) > 10240) {
        this.modalService.open(this.translate.instant('DOCUMENTS.FILE_SIZE_MUST_BE') + '10MB.');
        this.file = null;
        this.linkFile = null;
        this.fileInput.nativeElement.value = null;
        this.changeFile.emit(null);
        return false;
      }

      reader.readAsDataURL(file);
      reader.onload = () => {

        this.file = {
          filename: file.name,
          filetype: file.type,
          value: reader.result.split(',')[1]
        };

        this.changeFile.emit(this.file);

      };

      } else {
        this.modalService.open(this.translate.instant('FORMS.CAREGIVER.AVATAR_TOO_BIG'));
        this.file = null;
        this.fileInput.nativeElement.value = null;
        this.sendFile();
    }

  }

  private sendFile(): void {
    if (this.linkFile != null && !this.file) {
      this.changeFile.emit(this.linkFile);
    } else {
      this.changeFile.emit(this.file);
    }
  }

  deleteFile() {
    this.ngZone.run(() => {
      this.file = null;
      this.linkFile = null;
      this.changeFile.emit(null);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/file-uploader/file-uploader.component.ts